var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, FieldText, FieldTextarea, FlexBox, Text, } from '@dixa/lib-shared-habla';
import moment from 'moment-timezone';
import { useRef, useState } from 'react';
import { Field } from 'redux-form';
import { extractPkcs12 } from '../../platforms';
import styles from './submitModal.module.scss';
export function ApnsControls({ certPassword, addNotification, change, resetForm, }) {
    const inputRef = useRef(null);
    const [certFile, setCertFile] = useState(null);
    const onFile = (e) => {
        if (e.currentTarget.files.length === 0) {
            return;
        }
        const [file] = e.currentTarget.files || [];
        setCertFile(file);
        resetForm();
    };
    const setCredentials = () => __awaiter(this, void 0, void 0, function* () {
        if (!certFile) {
            console.warn('No file to read.');
            return;
        }
        const buff = yield certFile.arrayBuffer();
        const result = extractPkcs12(buff, certPassword);
        if (!result) {
            addNotification({
                title: 'Failed to extract certificate',
                text: `Make sure that certificate is valid and password is correct(if any)`,
                icon: 'exclamation',
                className: 'danger',
                time: 4000,
            });
            return;
        }
        change('platformCredential', result.privateKey);
        change('platformPrincipal', result.cert);
    });
    return (_jsxs(_Fragment, { children: [_jsxs(FlexBox, Object.assign({ flexDirection: "column", alignItems: "flex-start" }, { children: [_jsx(Text.Heading, Object.assign({ className: styles.textSpacing, variant: "heading-4" }, { children: "Choose the certificate to load credentials from" })), _jsxs(Button, Object.assign({ variant: "secondary", onClick: () => {
                            var _a;
                            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click();
                        } }, { children: ["Choose file", _jsx("input", { className: styles.fileInput, ref: inputRef, accept: "application/x-pkcs12", type: "file", onChange: onFile })] })), _jsxs(FlexBox, Object.assign({ className: styles.bottomSpacing, flexDirection: "column" }, { children: [_jsx(Text.Input, Object.assign({ className: styles.textSpacing, variant: "title" }, { children: "Valid .P12 files" })), certFile ? (_jsxs(_Fragment, { children: [_jsx(Text.Heading, Object.assign({ className: styles.textSpacing, variant: "heading-4" }, { children: certFile.name })), _jsx(Text.Paragraph, Object.assign({ className: styles.fileDescription, variant: "4" }, { children: moment(certFile.lastModified).format('L') }))] })) : null] }))] })), certFile ? (_jsxs(_Fragment, { children: [_jsx(Field, { component: FieldText, label: "Certificate password", name: "password", placeholder: "Enter password", type: "password" }), _jsx(Button, Object.assign({ className: styles.bottomSpacing, variant: "primary", onClick: setCredentials }, { children: "Load credentials from file" }))] })) : null, _jsx(Field, { component: FieldTextarea, label: "Certificate", name: "platformPrincipal", placeholder: "Apple certificate", required: true, type: "text" }), _jsx(Field, { component: FieldTextarea, label: "Private key", name: "platformCredential", placeholder: "Apple private key", required: true, type: "text" })] }));
}
